import { Link } from 'react-router-dom';
import { getNewComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const newComics = getNewComics(8);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16" aria-labelledby="latest-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 id="latest-title" className="text-xl md:text-2xl font-heading text-foreground-900 tracking-wide">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日准时更新，精彩不停歇</p>
          </div>
          <Link
            to="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}